/**
 * Modules
 */
import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
import _ from 'lodash'
// import t from '../translation'
/**
 * Composants
 */
import Dash from '../components/Dash'
import Login from '../components/Login'
import Dashboard from '../components/Dashboard'
import Trafic from '../components/Trafic'
import Visitors from '../components/trafic/Visitors'
import Chatting from '../components/trafic/Chatting'
import Monitoring from '../components/trafic/Monitoring'
import Attente from '../components/trafic/Attente'
import Stats from '../components/Stats'
import Audience from '../components/stats/Audience'
import Chats from '../components/stats/Chats'
import Chatbot from '../components/stats/Chatbot'
import AgentsPerformance from '../components/stats/AgentsPerformance'
import C2C from '../components/stats/C2C'
import Sales from '../components/stats/Sales'
import Leads from '../components/stats/Leads'
import Satisfaction from '../components/stats/Satisfaction'
import Reports from '../components/stats/reports/Reports'
import ReportDetails from '../components/stats/reports/ReportDetails'
import ViewCSV from '../components/stats/ViewCSV'
import Management from '../components/Management'
import Agents from '../components/management/Agents'
import Sites from '../components/management/Sites'
import Mapping from '../components/management/Mapping'
// import Group from '../components/management/Group'
import Settings from '../components/Settings'
import Preview from '../components/settings/Preview'
import Absence from '../components/settings/Absence'
import Chat from '../components/settings/Chat'
import Callback from '../components/settings/Callback'
import Sms from '../components/settings/Sms'
import Bot from '../components/settings/ChatBot'
// import Cobrowsing from '../components/settings/Cobrowsing'
import Ecomm from '../components/settings/Ecomm'
import Connectors from '../components/settings/Connectors'
import BluePush from '../components/settings/BluePush'
import Recall from '../components/settings/Recall'
// import Analytics from '../components/settings/Analytics'
// import Notifications from '../components/settings/Notifications'
import Target from '../components/Target'
import Filters from '../components/filters/Filters'
import Filter from '../components/filters/Filter'
import Media from '../components/Media'
import Biblios from '../components/media/Biblios'
import Biblio from '../components/media/Biblio'
import SubBiblio from '../components/media/SubBiblio'
import Pushs from '../components/media/Pushs'
import Push from '../components/media/Push'
import Profile from '../components/Profile'
import Account from '../components/Account'
import csvExport from '../components/stats/csvExport'
import { NO_ADMINS, NO_PEONS, NO_PEONS_NOR_AGENTS, LEVEL } from '../constants'
Vue.use(Router)
const router = new Router({
  mode: 'hash',
  base: 'watcheezy',
  routes: [
    /**
     * Login
     */
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    /**
     * Pour afficher les données trop grosses
     */
    {
      path: 'csvexport',
      name: 'csvexport',
      component: csvExport,
      meta: { permissions: { roles: NO_PEONS } }
    },
    /**
     * Dash
     */
    {
      path: '/',
      component: Dash,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        // le trafic
        {
          path: '/trafic',
          name: 'trafic',
          component: Trafic,
          meta: {
            tabs: [
              { title: 'visitors', to: '/trafic/visitors', brideName: 'trafic_visiteurs' },
              { title: 'chatting', to: '/trafic/chatting', brideName: 'trafic_discussions' },
              // { title: 'attente', to: '/trafic/attente', brideName: 'trafic_visiteurs' },
              { title: 'monitoring', to: '/trafic/monitoring', brideName: 'trafic_monitoring' }
              // { title: 'Contacts', to: '/trafic/contacts', brideName: 'trafic_monitoring' }
            ]
          },
          children: [
            {
              path: 'visitors',
              name: 'visitors',
              component: Visitors,
              meta: {
                permissions: { roles: NO_ADMINS },
                brideName: 'trafic_visiteurs'
              }
            },
            {
              path: 'chatting',
              name: 'chatting',
              component: Chatting,
              meta: {
                permissions: { roles: NO_ADMINS },
                brideName: 'trafic_discussions'
              }
            },
            {
              path: 'monitoring',
              name: 'monitoring',
              component: Monitoring,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS,
                  levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE]
                },
                brideName: 'trafic_monitoring'
              }
            },
            {
              path: 'attente',
              name: 'attente',
              component: Attente,
              meta: {
                permissions: { roles: NO_ADMINS },
                brideName: 'trafic_visiteurs'
              }
            }
          ]
        },
        // les stats
        {
          path: '/stats',
          name: 'stats',
          component: Stats,
          meta: {
            tabs: [
              { title: 'audience', to: '/stats/audience', brideName: 'stats_audience' },
              { title: 'chats', to: '/stats/chats', brideName: 'stats_conversations' },
              { title: 'chatbot', to: '/stats/chatbot', brideName: 'stats_chatbot' },
              { title: 'agents', to: '/stats/agents-perf', brideName: 'stats_conseillers' },
              { title: 'C2C', to: '/stats/C2C', brideName: 'stats_callback' },
              { title: 'sales', to: '/stats/sales', brideName: 'stats_ventes' },
              { title: 'leads', to: '/stats/leads', brideName: 'stats_leads' },
              { title: 'satisfaction', to: '/stats/satisfaction', brideName: 'stats_satisfaction' },
              { title: 'reports', to: '/stats/reports', brideName: 'stats_rapports' }
            ]
          },
          children: [
            {
              path: 'audience',
              name: 'audience',
              component: Audience,
              meta: {
                permissions: { roles: NO_PEONS },
                brideName: 'stats_audience'
              }
            },
            {
              path: 'chats',
              name: 'chats',
              component: Chats,
              meta: {
                permissions: { roles: NO_PEONS },
                brideName: 'stats_conversations'
              }
            },
            {
              path: 'chatbot',
              name: 'chatbot',
              component: Chatbot,
              meta: {
                permissions: { roles: NO_PEONS },
                brideName: 'stats_chatbot'
              }
            },
            {
              path: 'viewcsv',
              name: 'viewcsv',
              component: ViewCSV,
              meta: { permissions: { roles: NO_PEONS } }
            },
            {
              path: 'agents-perf',
              name: 'agents-perf',
              meta: {
                title: 'agents',
                permissions: { roles: NO_PEONS },
                brideName: 'stats_conseillers'
              },
              component: AgentsPerformance
            },
            {
              path: 'C2C',
              name: 'C2C',
              component: C2C,
              meta: {
                permissions: { roles: NO_PEONS },
                brideName: 'stats_callback'
              }
            },
            {
              path: 'sales',
              name: 'sales',
              component: Sales,
              meta: {
                permissions: {
                  roles: NO_PEONS,
                  levels: [
                    LEVEL.ESSAI,
                    LEVEL.START,
                    LEVEL.PRO,
                    LEVEL.ENTREPRISE
                  ]
                },
                brideName: 'stats_ventes'
              }
            },
            {
              path: 'leads',
              name: 'leads',
              component: Leads,
              meta: {
                permissions: {
                  roles: NO_PEONS,
                  levels: [
                    LEVEL.ESSAI,
                    LEVEL.START,
                    LEVEL.PRO,
                    LEVEL.ENTREPRISE
                  ]
                },
                brideName: 'stats_leads'
              }
            },
            {
              path: 'satisfaction',
              name: 'satisfaction',
              component: Satisfaction,
              meta: {
                permissions: { roles: NO_PEONS },
                brideName: 'stats_satisfaction'
              }
            },
            {
              path: 'reports',
              name: 'reports',
              component: Reports,
              meta: {
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS,
                  levels: [LEVEL.ENTREPRISE]
                },
                brideName: 'stats_rapports'
              }
            },
            {
              path: 'reports/:id',
              component: ReportDetails,
              meta: {
                back: '/stats/reports',
                tabs: null,
                permissions: {
                  roles: NO_PEONS_NOR_AGENTS,
                  levels: [LEVEL.ENTREPRISE]
                }
              },
              props: true
            }
          ]
        },
        {
          path: '/management',
          name: 'management',
          component: Management,
          meta: {
            tabs: [
              { title: 'agents', to: '/management/agents', brideName: 'compte_conseillers' },
              { title: 'sites', to: '/management/sites', brideName: 'compte_sites' },
              { title: 'mapping', to: '/management/mapping', brideName: 'compte_attribution' }
              // { title: 'groupe', to: '/management/group' }
            ]
          },
          children: [
            {
              path: 'agents',
              name: 'agents',
              component: Agents,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'compte_conseillers'
              }
            },
            {
              path: 'sites',
              name: 'sites',
              component: Sites,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'compte_sites'
              }
            },
            {
              path: 'mapping',
              name: 'mapping',
              component: Mapping,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'compte_attribution'
              }
            }
            // {
            // path: 'group',
            // name: 'group',
            // component: Group,
            // meta: { permissions: { roles: NO_PEONS_NOR_AGENTS } }
            // }
          ]
        },
        {
          path: '/settings',
          name: 'settings',
          component: Settings,
          meta: {
            tabs: [
              { title: 'preview', to: '/settings/preview', brideName: 'parametre_apercu' },
              { title: 'mode hors-ligne', to: '/settings/absence', brideName: 'parametre_absence' },
              { title: 'mode en-ligne', to: '/settings/chat', brideName: 'parametre_chat' },
              { title: 'widget + chatbot', to: '/settings/bot', brideName: 'parametre_bot' },
              { title: 'callback', to: '/settings/callback', brideName: 'parametre_callback' },
              { title: 'meeting', to: '/settings/recall', brideName: 'parametre_recall' },
              { title: 'sms', to: '/settings/sms', brideName: 'parametre_sms' },
              // { title: 'cobrowsing', to: '/settings/cobrowsing', brideName: 'parametre_cobrowsing' },
              { title: 'ecomm', to: '/settings/ecomm', brideName: 'parametre_ecommerce' },
              { title: 'connectors', to: '/settings/connectors', brideName: 'parametre_connecteur' },
              { title: 'bluepush', to: '/settings/bluepush', brideName: 'parametre_push' }
              // { title: 'analytics', to: '/settings/analytics', brideName: 'parametre_analytics' }
              // { title: 'notifications', to: '/settings/notifications' }
            ]
          },
          children: [
            {
              path: 'preview',
              name: 'preview',
              component: Preview,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'parametre_apercu'
              }
            },
            {
              path: 'absence',
              name: 'absence',
              component: Absence,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'parametre_absence'
              }
            },
            {
              path: 'chat',
              name: 'chat',
              component: Chat,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'parametre_chat'
              }
            },
            {
              path: 'bot',
              name: 'bot',
              component: Bot,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'parametre_bot'
              }
            },
            {
              path: 'callback',
              name: 'callback',
              component: Callback,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'parametre_callback'
              }
            },
            {
              path: 'recall',
              name: 'meeting',
              component: Recall,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'parametre_recall'
              }
            },
            {
              path: 'sms',
              name: 'sms',
              component: Sms,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'parametre_sms'
              }
            },
            /* {
              path: 'cobrowsing',
              name: 'cobrowsing',
              component: Cobrowsing,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'parametre_cobrowsing'
              }
            }, */
            {
              path: 'ecomm',
              name: 'ecomm',
              component: Ecomm,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'parametre_ecommerce'
              }
            },
            {
              path: 'connectors',
              name: 'connectors',
              component: Connectors,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'parametre_connecteur'
              }
            },
            {
              path: 'bluepush',
              name: 'bluepush',
              component: BluePush,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'parametre_push'
              }
            }
            /*
            {
              path: 'analytics',
              name: 'analytics',
              component: Analytics,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                brideName: 'parametre_analytics'
              }
            },
            {
              path: 'notifications',
              name: 'notifications',
              component: Notifications,
              meta: { permissions: { roles: NO_PEONS_NOR_AGENTS } }
            } */
          ]
        },
        {
          path: '/target',
          name: 'target',
          component: Target,
          meta: {
            tabs: [
              { title: 'scenario', to: '/target/filters', brideName: 'ciblage' }
              // { title: 'importExport', to: '/target/import' }
            ]
          },
          children: [
            {
              path: 'filters',
              name: 'filters',
              component: Filters,
              meta: {
                permissions: {roles: NO_PEONS},
                brideName: 'ciblage'
              }
            },
            {
              path: 'filters/:id',
              component: Filter,
              meta: {
                back: '/target/filters',
                tabs: null,
                permissions: { roles: NO_PEONS },
                brideName: 'ciblage'
              },
              props: true
            }
          ]
        },
        {
          path: '/media',
          name: 'media',
          component: Media,
          meta: {
            tabs: [
              { title: 'quickSentences', to: '/media/biblios', brideName: 'media_phrases' },
              // { title: 'pushs', to: '/media/pushs', brideName: 'media_push' }
              { title: 'pushs', to: '/media/pushs', brideName: 'parametre_push' }
            ]
          },
          children: [
            {
              path: 'biblios',
              name: 'biblios',
              component: Biblios,
              meta: {
                permissions: { roles: NO_PEONS },
                brideName: 'media_phrases'
              }
            },
            {
              path: 'biblios/:id',
              component: Biblio,
              meta: {
                back: '/media/biblios',
                tabs: null,
                permissions: { roles: NO_PEONS }
              },
              props: true
            },
            {
              path: 'biblios/:idParent/sub/:idSub',
              component: SubBiblio,
              meta: {
                back: '/media/biblios/:idParent',
                tabs: null,
                permissions: { roles: NO_PEONS }
              },
              props: true
            },
            {
              path: 'pushs',
              name: 'pushs',
              component: Pushs,
              meta: {
                permissions: { roles: NO_PEONS_NOR_AGENTS },
                // brideName: 'media_push'
                brideName: 'parametre_push'
              }
            },
            {
              path: 'pushs/:id',
              component: Push,
              meta: {
                back: '/media/pushs',
                tabs: null,
                permissions: { roles: NO_PEONS_NOR_AGENTS }
              },
              props: true
            }
          ]
        },
        {
          path: 'profile',
          name: 'profile',
          component: Profile
        },
        {
          path: 'account',
          name: 'account',
          component: Account,
          meta: { permissions: { roles: NO_PEONS_NOR_AGENTS } }
        }
      ]
    },
    {
      path: '*',
      redirect: '/stats/audience'
    }
  ]
})
/**
 * Avant chaque accès à une nouvelle route
 * @param   {Router}    (to, from)  Router pris en charge, route de départ et route d'arrivée
 * @param   {Function}  next        se rend au router d'arrivée
 */
router.beforeEach((to, from, next) => {
  console.log('to :', to)
  console.log('from :', from)
  console.log('next :', next)
  let _User = {
    account: store.getters['_User/account'],
    level: store.getters['_User/level'],
    entId: store.state._User.entId,
    hideTabVisitors: store.state._User.hideTabVisitors,
    brides: store.state._User.brides
  }
  /**
   * gestion de la route en fonction de :
   * - l'état de la connection de l'utilisateur
   * - la licence
   */
  let connected = store.getters.logged
  if (!connected) {
    if (to.path !== '/login') {
      router.push({ path: '/login' })
      next(false)
    } else {
      next(true)
    }
    return
  } else if (connected) {
    if (!_User.level) {
      store.commit('logout')
    } else if (to.path === '/' || to.path === '/login') {
      if (_User.account.role === 'peon') {
        router.push({ path: '/trafic/visitors' })
      } else {
        router.push({ path: '/stats/audience' })
      }
    }
  }
  // if (to.meta.brideName) {
  //   // let brideStatus = _User.brides.find(a => a.brideName === 'parametre_chat')
  //   let brideStatus = _.find(_User.brides, function (o) { return o.brideName === to.meta.brideName })
  //   console.log('brideName', brideStatus)
  //   // console.log('brideName', _User.brides.brideName)
  // }
  // dans le cas où il faut une permission pour accéder à cette route
  // vérification des droits
  let permission = true
  let because = null
  if (to.meta.permissions) {
    // test de la présence du role du user dans la liste des permissions de la route
    permission =
      !to.meta.permissions.roles ||
      (to.meta.permissions.roles &&
        _.indexOf(to.meta.permissions.roles, _User.account.role) !== -1)
    because = permission ? null : 'account'
    // et de la licence si permission
    // sinon pas la peine d'aller plus loin
    if (permission) {
      permission =
        !to.meta.permissions.levels ||
        (to.meta.permissions.levels &&
          _.indexOf(to.meta.permissions.levels, _User.level.rights) !== -1)
      because = permission ? null : 'level'
    }
    // ------------------------------------------------------------------------------------
    // Brides
    // interdiction d'acceder à cette page si status = 0
    if (_User.brides) {
      let brideStatus = _User.brides.find(function (o) {
        return o.brideName === to.meta.brideName
      })
      // console.log('brideStatus', brideStatus)
      if (brideStatus) {
        if (brideStatus.status === '0') {
          permission = false
        }
      }
    }
  }
  if (permission) {
    // console.log('_User.role', _User.account.role)
    /**
     * MAJ onglets
     */
    // vide les onglets si la route spécifie explicitement
    // qu'elle n'a pas d'onglets (tabs à null)
    // exemple: route avec la flèche de retour
    let updateTabs = !_.isNull(to.meta.tabs)
    if (!updateTabs) {
      // vide le système d'onglets
      store.commit('_Toolbar/SET_TABS', [])
    } else if (to.matched.some(route => route.meta.tabs)) {
      // test si une autre route identique possède des onglets
      // recherche parmis les routes qui matchent, la liste des onglets qu'il faut récupérer
      let tabs = _.find(to.matched, route => {
        return route.meta.tabs
      })
      tabs = tabs.meta.tabs
      // console.log('tabs', tabs)
      // ------------------------------------------------------------------------------------
      // check si l'agent est autorisé à voir la section de ce menu
      // console.log('_User.brides', _User.brides)
      let i
      for (i = tabs.length - 1; i >= 0; i -= 1) {
      // tabs.forEach(function (element, index) {
        if (tabs[i].brideName) {
          // regarde si un bride est  appliqué à cette section dans le menu
          if (_User.brides) {
            let brideStatus = _.find(_User.brides, function (o) { return o.brideName === tabs[i].brideName })
            // console.log('brideStatus', brideStatus)
            tabs[i].status = brideStatus.status
            // si il n'est pas autorisé à voir cette section
            if (brideStatus.status === '0') {
              // on l'efface du menu
              // console.log('efface index', i + ' - ' + tabs[i].brideName)
              // tabs.splice(i, 1)
            }
          }
        }
      }
      let newTabs = tabs
      // console.log('tabs', tabs)
      // -------------------------------------------------------------------------------------
      // en fonction de la permission
      newTabs = _.filter(newTabs, t => {
        // Si pas d'onglet visitors
        if (_User.hideTabVisitors) {
          if (t.title !== 'visitors') {
            return t
          }
          return
        }
        // retire le nom de la tab menu
        // let brideStatus2 = _User.brides.find(function (o) {
        //   return o.brideName === t.brideName
        // })
        // console.log('brideStatus', brideStatus2)
        // if (brideStatus2) {
        //   if (brideStatus2.status === '1') {
        //     if (t.brideName === 'compte_conseillers') {
        //       console.log('compte_conseillers')
        //     }
        //     if (_User.account.role === 'agent' || _User.account.role === 'peon') {
        //       if (t.title !== 'monitoring') {
        //         return t
        //       }
        //     } else if (_User.account.role === 'admin') {
        //       if (t.title !== 'visitors' && t.title !== 'chatting') {
        //         return t
        //       }
        //     } else {
        //       return t
        //     }
        //   }
        // }
        if (_User.account.role === 'agent' || _User.account.role === 'peon') {
          if (t.title !== 'monitoring') {
            return t
          }
        } else if (_User.account.role === 'admin') {
          if (t.title !== 'visitors' && t.title !== 'chatting') {
            return t
          }
        } else {
          return t
        }
      })
      store.commit('_Toolbar/SET_TABS', newTabs)
    } else {
      // vide le système d'onglets
      store.commit('_Toolbar/SET_TABS', [])
    }
    /**
     * MAJ du titre de la toolbar
     */
    let title = to.fullPath
    // suppression de l'id dans le chemin, si présent
    if (!_.isEmpty(to.params.id)) {
      let paths = to.fullPath.split('/')
      title = ''
      for (var i = 0; i < paths.length - 1; i++) {
        title += paths[i]
        if (i !== paths.length - 2) {
          title += '/'
        }
      }
    }
    // si un title est spécifié explicitement pour la vue
    title = to.meta.title
      ? '/' + title.split('/')[1] + '/' + to.meta.title
      : title
    store.commit('_Toolbar/SET_TITLE', title.substring(1).split('/')[0])
    /**
     * MAJ flèche de retour
     */
    to.meta.back
      ? store.commit('_Toolbar/SET_BACK', to.meta.back)
      : store.commit('_Toolbar/SET_BACK', null) // efface la flèche de retour
    /**
     * MAJ du sous-titre de la toolbar se fera dans le composant directement
     */
    if (to.meta.back) {
      store.commit('_Toolbar/SET_SUB_TITLE', null)
    }
    /**
     * MAJ du visiteur focus si pas sur une page trafic
     * alors perte de focus, afin d'avoir les notifications
     */
    if (to.name !== 'trafic') {
      store.commit('_StoreWatcheeBox/AGENT_FOCUS', {
        view: 1,
        visiteurID: 1
      })
    }
    next()
    // vide le tableau des notifications
    store.commit('_Notifier/CLEAR')
  } else {
    // si pas de permission alors pas de changement de route
    // et notification du manque de permission
    next(false)
    // let path = t.messages[t.locale][to.path.split('/')[1]] || to.path.split('/')[1]
    store.dispatch('_Notifier/NEW_NOTIF', {
      // message: `En tant que ` + _User.account.type + `, vous ne pouvez accéder à la section : '` + path + `'`,
      message:
        because === 'account'
          ? `En tant que ` +
            _User.account.type +
            `, vous ne pouvez accéder à cette section`
          : `Le niveau de licence (` +
            _User.level.title +
            `) n'est pas suffisant, vous ne pouvez accéder à cette section`,
      multiLine: true,
      context: 'error',
      position: 'top'
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js